import {apiStore} from "@/stores/api";
import {measurementStore} from "@/stores/measurement";
import {formatTime, getDateForPicker, newDateFromString} from "@/utils/utils";

export default {
    data() {
        return {
            appointments: [],
            date : getDateForPicker(new Date()),
            loading : false
        };
    },

    async created() {
        await this.getAppointmentsForDate();
        await this.getUpdatedAppointments();

        measurementStore().on("measurement_saved", this.onMessage);
        measurementStore().on("movie_completed", this.onMessage);

        document.addEventListener("visibilitychange", this.handleVisibilityChange);
    },

    destroyed() {
        measurementStore().off("measurement_saved", this.onMessage);
        measurementStore().off("movie_completed", this.onMessage);

        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    },

    watch: {
        date() {
            this.getAppointmentsForDate();
        }
    },

    methods : {
        async getAppointmentsForDate() {
            this.loading = true;

            // capture the requested date so a stale, out-of-order response can't overwrite newer data
            const requestedDate = this.date;
            const appointments = await apiStore().getAppointments(requestedDate);

            if (requestedDate !== this.date) {
                return;
            }

            this.appointments = appointments;
            this.loading = false;
        },

        async getUpdatedAppointments() {
            apiStore().getUpdatedAppointments();
        },

        onMessage() {
            setTimeout(() => {
                this.getAppointmentsForDate();
            }, 500);
        },

        formatAppointmentTime(appointment) {
            if (appointment.date) {
                const date = newDateFromString(appointment.date);
                return formatTime(date);
            }
        },

        handleVisibilityChange() {
            if (!document.hidden) {
                this.getAppointmentsForDate();
                this.getUpdatedAppointments();
            }
        }

    }
};
